import React, { useContext, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import AddDependentsByFile from './sections/AddDependentsByFile/AddDependentsByFile';
import { ReactComponent as Alert } from '../../../assets/icons/v3/alert-circle.svg';
import BdsLinearProgressIndicator from '../../../shared/components/v3/BdsLinearProgressIndicator/BdsLinearProgressIndicator';
import SecondaryHero from '../../../shared/components/v3/Heros/SecondaryHero/SecondaryHero';
import BdsModal from '../../../shared/components/v3/Modals/BdsModal/BdsModal';
import { MANAGE_COLLABORATORS_ROUTE } from '../../../shared/constants/auth';
import { PlansContext } from '../../../shared/context/plans/plansContext';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../shared/translations/manageCollaborators';

import './AddCollaboratorsDependents.scss';

const AddCollaboratorsDependents = () => {
  const [progress, setProgress] = useState<number>(Math.min((2 / 3) * 100, 100));
  const [openModal, setOpenModal] = useState<boolean>(true);

  const { plans } = useContext(PlansContext);

  const dependentPlanNames = plans.filter((plan) => plan.supportDependents).map((plan) => plan.name);

  const allDependents = dependentPlanNames.length === plans.length;
  const namesExceptLast = dependentPlanNames.slice(0, -1).join(', ');
  const lastPlanName = dependentPlanNames.at(-1) ?? '';

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleActionBack = () => {
    navigate(MANAGE_COLLABORATORS_ROUTE, { state: { method: 'addDependents' } });
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <div className="manage-collaborators-container">
      <SecondaryHero
        title={t(TRANSLATION_MANAGE_COLLABORATORS.hero.addDependents.title)}
        description={t(TRANSLATION_MANAGE_COLLABORATORS.hero.addDependents.subtitle)}
        color="surface-container-quaternary-light"
        bottomContent={<BdsLinearProgressIndicator variant="subtle" size="s" progress={progress} />}
        backAction={handleActionBack}
      />
      <div className="manage-collaborators-content">
        <AddDependentsByFile setProgress={setProgress} />
      </div>
      <BdsModal
        open={!allDependents && openModal}
        className="add-collaborators-dependents-modal"
        icon={<Alert />}
        title={t(TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.modal.title)}
        description={
          <Trans
            i18nKey={TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.modal.description}
            values={{ plans: namesExceptLast, lastPlan: lastPlanName }}
            count={dependentPlanNames.length}
            components={{
              b: <b></b>
            }}
          />
        }
        primaryAction={{
          label: t(TRANSLATION_MANAGE_COLLABORATORS.addDependentsCard.modal.button),
          onClick: handleCloseModal
        }}
        onBackdropClick={handleCloseModal}
      />
    </div>
  );
};

export default AddCollaboratorsDependents;
